module.exports = __webpack_public_path__ + "img/icon-shield-green.5d55ce95.svg";